import { ReactComponent as SVGCoin } from "../../svg/jinbi2.svg"
import { ReactComponent as SVGRefresh } from "../../svg/refresh2.svg"
import { ReactComponent as SVGMenu } from "../../svg/menu.svg"
import { ReactComponent as BackSvg } from "../../svg/back.svg"

export default ({ name, coins, face_img, onRefresh, onBack , show = true}) => {

    return <div style={{  width: "100%", margin: 'auto', paddingTop: "0.2rem",   background:"#fff", justifyContent: "center" }}>
        <div style={{width: "100%", display: "flex", justifyContent: "space-between", padding:"0 0.08rem 0 0.02rem", boxSizing:"border-box" }}>
            <div><BackSvg   onClick={() => {
                if (onBack) {
                    onBack?.()
                } else {
                    window.history.back();
                }
            }} style={{ width: "0.25rem", height: "0.25rem",marginLeft:"0.1rem" }} /></div>
            <div style={{color:"#000D20", fontSize:"0.18rem", fontWeight:"bold", letterSpacing:"2px"}}>儲值</div>
            <div><SVGMenu onClick={() => { window.location.href = "#/setting" }} className="btn" fill="#000D20" style={{ width: "0.24rem", height: "0.24rem", marginRight:"0.1rem"}} /></div>

        </div>
            {show ? <div style={{ display:"flex", justifyContent:"space-between", padding:"0.25rem 0.31rem 0.2rem 0.31rem"}}>
            <div style={{display:"flex", flexDirection:"column", justifyContent:"space-evenly"}}>
                <div style={{fontSize:"0.18rem", color:"#000D20", fontWeight:"bold", letterSpacing:"2px"}}>帳戶餘額 <span style={{fontSize:"0.2rem", color:"#01C386", letterSpacing:"0px", fontWeight:"bold"}}>￥{parseFloat(coins) || '0.00'}</span></div>
                {/* <div style={{fontSize:"0.12rem", color:"#000D20"}}>一元等於一個幣</div> */}
            </div>
            {face_img}
        </div>:''}
    </div>
}